import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Subscription } from 'rxjs';
import { EntityListPayloadModel } from 'src/app/model';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from '../../../services/entities-service.service';

@Component({
  selector: 'app-lane-tagging',
  templateUrl: './lane-tagging.component.html',
  styleUrls: ['./lane-tagging.component.css']
})
export class LaneTaggingComponent implements OnInit, OnDestroy {

  availableMonotainers: any = [];
  laneTagForm: FormGroup;
  userSubmit: boolean = false;
  successMessage: any = [];
  errorMessage: any = [];

  private _updateReaSubscription: Subscription;
  private _entitiesListSubscription: Subscription;

  
  constructor(public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _fb: FormBuilder,
    private _sharedService: ServicecallService,
    private _entityService: EntitiesServiceService) { }

  ngOnInit(): void {
    this._getMonotainers();
    this.laneTagForm = this._fb.group({
      entity: ['', [Validators.required]],
    });
  }
  ngOnDestroy(): void {
    this._updateReaSubscription?.unsubscribe(); 
    this._entitiesListSubscription?.unsubscribe(); 

  }
  get laneTagFormValues() {
    return this.laneTagForm.controls;
  }
  resetForm() {
    this.laneTagForm.reset();
  }

  submitForm() {
    this.userSubmit = true;
    if (this.laneTagForm.invalid && this.userSubmit) {
      return;
    } else {
      const reqData: any = {
        zones: this.data?.msg === 'tag' ? [this.data?.item?.zoneId] : [],
        entityIds: this.laneTagForm.value.entity,
        siteId: this.data?.item?.site
      }
      this._updateReaSubscription = this._entityService.updateRea(reqData).subscribe(
        {
          next: (result: any) => {
            if (result) {
              this.successMessage = [];
              this.errorMessage = [];
              // this.sharedService.toasterService({ type: 'success', msg: Messages.SUCCESS });
              // this.dialogRef.close(true);
              result?.entityTagIds?.forEach(success => {
                this.successMessage.push(success?.uniqueId);
              });
              result?.errorInEntities?.forEach(element => {
                const error = element?.uniqueId + " - " + element?.error;
                this.errorMessage.push(error);
              });
            }
          },
          error: () => {
          }
        }
      )
    }
  }

  closeDialogue() {
    if (this.successMessage.length || this.errorMessage.length) {
      this.dialogRef.close(true);
    } else {
      this.dialogRef.close();
    }
  }
  private _getMonotainers() {
    const payloadContent: Partial<EntityListPayloadModel> = {
      status: true,
      siteId: this._sharedService.getSiteId(),
      type: 2,
      category: this._sharedService.getConfiguration('tenantCategory') ? this._sharedService.getConfiguration('tenantCategory').tenantCategory?.category : null,
    };
    if (this.data?.msg === 'tag') {
      this._entitiesListSubscription = this._sharedService.entitiesList(payloadContent, null).subscribe((result: any) => {
        if (result['status']) {
          this.availableMonotainers = result['response']['data']?.[0]?.['data']?.filter((item: any) => item.assetDetails?.state === 'init');
        } else {
          this.availableMonotainers = [];
          this._sharedService.toasterService({ type: 'error', msg: result?.response?.message });
        }
      });
    } else {
      this.availableMonotainers = this.data?.monotainers?.filter((item: any) => item?.state === 'outside' || item?.state === 'missing' || item?.state === 'sortarea');
      this.availableMonotainers?.map((item: any) => {
        item._id = item.entityId;
      });
    }
  }

}
